export const LANDING_PAGE_CMS_DATA = "/apim-admin";
export const GRAPHQL_PROXY = "api/graphql-proxy";